import { TextWidgetSetupType } from "../types/setups/textWidgetSetupType";
import { WidgetSetupType } from "../types/types";

export const isTextWidgetSetup = (
  setup: WidgetSetupType,
): setup is TextWidgetSetupType => {
  return setup.widgetType === "text";
};
